<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-alert :show="storeState.showAlert" :variant="storeState.alertVariant">
            {{ storeState.alertMsg }}
          </b-alert>
          <b-card no-body class="p-4">
            <b-card-body class="text-center">
              <p class="mb-4"><img src="/img/brand/logo-tamasia-full.png" width="89" height="32" alt="Tamasia Logo"></p>
              <b-form id="email-form">
                <p class="text-muted">Login to your partner account</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-envelope"/></b-input-group-text></b-input-group-prepend>
                  <b-form-input v-model="input.email" type="email" class="form-control" name="email" placeholder="Email" autocomplete="email" />
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-key"/></b-input-group-text></b-input-group-prepend>
                  <b-form-input v-model="input.password" type="password" class="form-control" name="password" placeholder="Password"/>
                </b-input-group>
                <b-button v-if="!localState.isLoading" :disabled="emailIsNotValid" variant="primary" class="px-4 mt-2" @click="login()">Login</b-button>
              </b-form>
              <b-button v-if="localState.isLoading" variant="secondary" class="mt-2"><i class="fa fa-spinner fa-spin"/> Loading</b-button>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { store } from '@/shared/store'
import { isValidEmail } from '@/shared/utils'
import { login, handleError } from '@/services/metal'
export default {
  name: 'Login',

  data() {
    return {
      input: {
        email: null,
        password: null,
      },
      localState: {
        isLoading: false,
      },
      storeState: store.state,
    }
  }, // data()

  computed: {
    emailIsNotValid: function() {
      return !isValidEmail(this.input.email)
    },

  }, // computed

  methods: {
    toggleLoading() {
      this.localState.isLoading = !this.localState.isLoading
    },

    login() {

      if (!this.input.email || !this.input.password) {
        store.showAlert('Email & Password is required', 'danger')
        return
      } else if (!isValidEmail(this.input.email)) {
        store.showAlert('Email is not valid', 'danger')
        return
      }

      this.toggleLoading()

      login(this.input.email, this.input.password)
        .then(response => {
          store.hideAlert()

          localStorage.userToken = response.data.data.access_token
          localStorage.email = this.input.email

          this.$router.push('/')
        })
        .catch(error => {
          handleError(error)
        })
        .then(() => {
          this.toggleLoading()
        })
    }

  } // methods
}
</script>
